import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (machineIds, siteId, proceed) => {
  const endpoint = `${apiEndpoints.sites}/${siteId}/machines`
  const URL = SERVER_PATH + endpoint
  const requestBody = {
    machineIds,
    proceed
  }
  return resolveRequest(axios.post(URL, requestBody, { withCredentials: true }))
}
